module.exports = __webpack_public_path__ + "img/hennenberg_2016_ref.3b1e586c.jpg";